import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
import util from '../lib/util'

import { Loading, Message, MessageBox } from 'element-ui'

import { includes } from 'lodash'
// import Cookies from 'js-cookie'
import * as log from 'loglevel'
import { INIT_CURRENT_RUBRIC } from '../store/types/rubric'

import { SET_PROBLEM_LABEL } from '../store/types/chunk'

const HomeView = () =>
  import(/* webpackChunkName: 'home' */ '../views/Home.vue')
const PageView = () =>
  import(/* webpackChunkName: 'page' */ '../views/Page.vue')
const PDFView = () => import(/* webpackChunkName: 'pdf' */ '../views/PDF.vue')
const ReportView = () =>
  import(/* webpackChunkName: 'report' */ '../views/Report.vue')
const ResponsePreviewView = () =>
  import(/* webpackChunkName: 'response-preview' */ '../views/ResponsePreview.vue')
const UserView = () =>
  import(/* webpackChunkName: 'user' */ '../views/User.vue')
const MobileView = () =>
  import(/* webpackChunkName: 'mobile-view' */ '../views/MobileView.vue')

const Login = () =>
  import(/* webpackChunkName: 'login' */ '../schemes/larva/Login.vue')
const NotFound = () =>
  import(/* webpackChunkName: 'not-found' */ '../schemes/larva/NotFound.vue')
const Maintenance = () =>
  import(/* webpackChunkName: 'maintenance' */ '../schemes/larva/Maintenance.vue')
const GoTraining = () =>
  import(/* webpackChunkName: 'go-training' */ '../schemes/larva/GoTraining.vue')

Vue.use(Router)

let router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      component: Login,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/',
      component: HomeView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/maintenance',
      component: Maintenance,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/home',
      component: HomeView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/please-go-to-training-page',
      component: GoTraining,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/mobile/:label',
      component: MobileView,
      meta: {
        requireAuth: true
      }
    },
    // {
    //   path: '/test',
    //   component: Test
    // },
    {
      path: '/user',
      component: UserView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/user/:id',
      component: UserView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/page/:id',
      name: 'problemPage',
      component: PageView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/page/:id/chunk/:chunkId',
      component: PageView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/larva/page/:id',
      component: PageView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/report/:id',
      component: ReportView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/pdf/:id',
      component: PDFView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/response-preview/:id',
      component: ResponsePreviewView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/larva/page/:id/chunk/:chunkId',
      component: PageView,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '*',
      component: NotFound,
      meta: {
        requireAuth: false
      }
    }
  ]
})

const LOGIN_URL = '/login'
const MAINTENANCE_URL = '/maintenance'
const PASS_THROUGH_URLS = [MAINTENANCE_URL, LOGIN_URL]

const PROBLEM_LABEL_MARKER = '?problem='
const TRAIN_PHASE_MARKER = '?phase=train'
const PROBLEM_REDIRECT = 1
const TRAIN_REDIRECT = 2

function checkRedirection(location) {
  let redirect = null
  let problemLabel = null
  let search = location.search
  if (search.startsWith(PROBLEM_LABEL_MARKER)) {
    redirect = PROBLEM_REDIRECT
    problemLabel = search.substring(PROBLEM_LABEL_MARKER.length)
  } else if (search.startsWith(TRAIN_PHASE_MARKER)) {
    redirect = TRAIN_REDIRECT
  }
  return { redirect, problemLabel }
}

async function redirectPage(problemLabel) {
  let loading = Loading.service({ fullscreen: true, text: 'Loading page' })
  console.log('problemLabel', problemLabel)
  if (problemLabel) {
    if (store.getters.browser.versions.isMobile) {
      window.location.href = '/#/mobile/' + problemLabel
      return true
    }
    try {
      let map = await store.dispatch('getProblemByLabel', problemLabel)
      loading.close()
      if (map.success && map.qid) {
        window.location.href = '/#/page/' + map.qid
      }
      return true
    } catch (err) {
      loading.close()
      MessageBox.alert(
        'The problem can not be found or you are not authorised to access the problem',
        'Failed to access the problem',
        {
          confirmButtonText: 'OK',
          callback: action => {
            const url = store.state.platform['T&E Portal URL']
            if (url) {
              window.location.href = url
            } else {
              window.location.href = '/#/home'
            }
          }
        }
      )
    }
  }
  return false
}

router.beforeEach(async function(to, from, next) {
  log.info('beforeEach', to.path, to.from, to, from)

  if (to.path === MAINTENANCE_URL) {
    next()
    return
  }
  await store
    .dispatch('getVersion')
    .then(function() {
      if (to.query.api) {
        store.commit('SET_API_PROVIDER', to.query.api)
      }
      if (to.query.super) {
        // super user can force
        next()
      }
    })
    .catch(function() {
      next('/maintenance')
    })

  const { requireAuth } = to.meta
  if (!requireAuth) {
    next()
    return
  }

  util.setDocumentTitle()

  const isTNEMode = store.state.platform['API mode'] === 'T&E'
  if (
    to.path === '/' &&
    window.location.pathname === '/' &&
    !(
      window.location.search.includes(PROBLEM_LABEL_MARKER) ||
      window.location.search.includes(TRAIN_PHASE_MARKER)
    ) &&
    isTNEMode
  ) {
    const tnePortalUrl = store.state.platform['T&E Portal URL']
    if (isTNEMode && tnePortalUrl && tnePortalUrl !== 'N/A') {
      window.location = tnePortalUrl
      return
    }
  }

  if (to.query.token || (to.query.username && to.query.password)) {
    const query = to.query
    store.dispatch('hardLogin', query).then(async function() {
      store
        .dispatch(INIT_CURRENT_RUBRIC)
        .then(function() {
          if (to.path === '/') {
            next('/home')
          } else {
            next()
          }
        })
        .catch(function(err) {
          throw err
        })
    })
    return
  }
  let { redirect, problemLabel } = checkRedirection(window.location)
  let isTNE = redirect
  if (isTNE && isTNEMode) {
    store.commit('SET_AUTH_PROVIDER', 'tne')
  }
  if (problemLabel && isTNEMode) {
    store.commit(SET_PROBLEM_LABEL, problemLabel)
  }

  store
    .dispatch('checkAuthState')
    .then(async function(isAuthenticated) {
      log.info('isAuthenticated: ', isAuthenticated, from, to)
      if (isAuthenticated) {
        const email = store.state.user.currentUser.email
        if (redirect === TRAIN_REDIRECT) {
          let showCancelButton = isTNEMode
          MessageBox.alert(
            "(You'll be asked to choose password when signing in for the first time)",
            'Please click "OK" to sign in to the SWARM Learning Center and complete your training.',
            {
              showClose: false,
              showCancelButton: showCancelButton,
              confirmButtonText: 'OK',
              cancelButtonText: 'Return to the CREATE portal',
              callback: action => {
                if (action === 'confirm') {
                  if (email) {
                    window.location.href = encodeURI(
                      `https://swarm-learning.thinkific.com/users/express_signin?email=${email}`
                    )
                  } else {
                    console.error(
                      'No user email found,',
                      store.state.user.currentUser
                    )
                    window.location.href =
                      'https://swarm-learning.thinkific.com/bundles/createbetterreasoning'
                  }
                } else {
                  const url = store.state.platform['T&E Portal URL']
                  if (url) {
                    window.location.href = url
                  }
                }
              }
            }
          )
          return
        }
        const { trainingStatus } = store.state.user.currentUser
        if (trainingStatus) {
          store
            .dispatch(INIT_CURRENT_RUBRIC)
            .then(function() {
              if (problemLabel && isTNEMode) {
                redirectPage(problemLabel)
              } else if (
                to.path === '/' ||
                includes(PASS_THROUGH_URLS, to.path)
              ) {
                // prevent infinite redirect to paths in PASS_THROUGH_URLS
                next('/home')
              } else {
                next()
              }
            })
            .catch(function(err) {
              throw err
            })
        } else {
          /*
          if (to.path === '/please-go-to-training-page') {
            next()
          } else {
            next('/please-go-to-training-page')
          }
          */
          // TODO: Move this part to src/schemes/larva/GoTraining.vue (/please-go-to-training-page).
          let showCancelButton = isTNEMode
          MessageBox.alert(
            "(You'll be asked to choose password when signing in for the first time)",
            'Please click "OK" to sign in to the SWARM Learning Center and complete your training.',
            {
              showClose: false,
              showCancelButton: showCancelButton,
              confirmButtonText: 'OK',
              cancelButtonText: 'Return to the CREATE portal',
              callback: action => {
                if (action === 'confirm') {
                  if (email) {
                    window.location.href = encodeURI(
                      `https://swarm-learning.thinkific.com/users/express_signin?email=${email}`
                    )
                  } else {
                    console.error(
                      'No user email found,',
                      store.state.user.currentUser
                    )
                    window.location.href =
                      'https://swarm-learning.thinkific.com/bundles/createbetterreasoning'
                  }
                } else {
                  const url = store.state.platform['T&E Portal URL']
                  if (url) {
                    // TODO: Change this to url only once T&E fixes the routing issue in T&E's portal.
                    window.location.href = `${url}/home.html`
                  }
                }
              }
            }
          )
        }
      } else {
        store.dispatch('logout')
        throw new Error('Please re-login')
      }
    })
    .catch(function(err) {
      if (includes(PASS_THROUGH_URLS, to.path)) {
        // prevent infinite redirect to paths in PASS_THROUGH_URLS
        next()
      } else {
        if (isTNE && isTNEMode) {
          MessageBox.alert(
            'You probably need to re-login or you are not authorised to use SWARM on this problem. Please contact administrators for further explanation',
            'Failed authentication or authorization',
            {
              confirmButtonText: 'OK',
              callback: action => {
                let url = store.state.platform['T&E Portal URL']
                if (url) {
                  window.location.href = url
                }
              }
            }
          )
        } else {
          Message({
            showClose: true,
            message: (err && err.message) || 'Unidentified system error',
            type: 'error'
          })
          next({
            path: '/login',
            query: {
              redirect: to.path
            }
          })
        }
      }
    })
})

export default router
